module.exports = __webpack_public_path__ + "img/neutral-towers-logo.f3664ba4.png";